<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div>
                <b-alert show variant="info">
                    Upload a CSV file. Your file must have the first column as <b>number</b> second column as
                    <b>amount</b> third column as <b>provider</b>
                </b-alert>
            </div>
            <div class="col-lg-8">
                <b-card title="Bulk Airtime Upload" type="secondary" shadow header-classes="bg-white pb-5"
                    body-classes="px-lg-5 py-lg-5">
                    <b-card-text>
                        <b-form enctype="multipart/form-data">
                            <b-row>
                                <b-col sm="12" md="6">
                                    <b-form-group label="Brief Description:" label-for="input-1">
                                        <b-form-input v-model="form.description" placeholder="Description" required>
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" md="6">
                                    <b-form-group label="Country to top up for:">
                                        <b-form-select placeholder="Country" v-model="form.isoCountry"
                                            :options="options">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-radio v-model="productSelected" :aria-describedby="ariaDescribedby"
                                        name="some-radios" value="airtime">Airtime</b-form-radio>
                                    <b-form-radio v-model="productSelected" :aria-describedby="ariaDescribedby"
                                        name="some-radios" value="data">Data</b-form-radio>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="isDataSelected()">
                                <b-col sm="12" md="6">
                                    <b-form-group label="Provider:">
                                        <b-form-select placeholder="Country" v-on:change="getPriceList()"
                                            v-model="form.selectedPortifolio" :options="providerOptions">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" md="6">
                                    <b-form-group label="Type:">
                                        <select v-model="selectedProduct" required class="form-control">
                                            <option v-for="(value, name, index) in priceList.productList" :value="value"
                                                :key="name">
                                                <span>
                                                    {{value.description}}
                                                </span>
                                            </option>
                                        </select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-form-group label="File:" label-for="input-1">
                                <b-form-file v-model="file1" :state="Boolean(file1)"
                                    placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here...">
                                </b-form-file>
                            </b-form-group>
                            <div>
                                <b-button type="button" @click="onUpload" variant="primary" class="my-3">Process
                                </b-button>
                                <br />
                                <a href="/csv/umbai_airtime_sample.csv " title="Download sample file"
                                    download="umbai_airtime_sample.csv">

                                    Download Sample Airtime File
                                </a>
                                <br />
                                <a href="/csv/umbai_data_sample.csv " title="Download sample file"
                                    download="umbai_data_sample.csv">

                                    Download Sample Data File
                                </a>
                            </div>
                        </b-form>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </div>
</div>